module.exports = __webpack_public_path__ + "static/img/group.4829214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/group.png
// module id = p8xB
// module chunks = 6